import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { FolderDown, Loader2 } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { saveBlob } from '../../lib/download';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Filtre période (date d'émission) + téléchargement ZIP de tous les PDF de la sélection filtrée
export const FiltrePeriode = ({ periode, onChange }) => (
  <div className="flex items-center gap-2" data-testid="factu-filtre-periode">
    <Input type="date" value={periode.du} onChange={(e) => onChange({ ...periode, du: e.target.value })} className="w-40" title="Émises du" data-testid="factu-periode-du" />
    <span className="text-slate-400 text-sm">au</span>
    <Input type="date" value={periode.au} onChange={(e) => onChange({ ...periode, au: e.target.value })} className="w-40" title="Émises au" data-testid="factu-periode-au" />
    {(periode.du || periode.au) && (
      <Button variant="ghost" size="sm" onClick={() => onChange({ du: '', au: '' })} data-testid="factu-periode-reset">Effacer</Button>
    )}
  </div>
);

export const estDansPeriode = (doc, periode) => {
  if (!periode.du && !periode.au) return true;
  const d = doc.date_emission || (doc.created_at || '').slice(0, 10);
  if (!d) return false;
  return (!periode.du || d >= periode.du) && (!periode.au || d <= periode.au);
};

export const BoutonTelechargerZip = ({ documents, nomArchive }) => {
  const [loading, setLoading] = useState(false);
  const ids = documents.map((d) => d.id);

  const telecharger = async () => {
    if (!ids.length) return;
    setLoading(true);
    try {
      const res = await axios.post(`${API}/documents/zip`, { document_ids: ids, nom_archive: nomArchive }, { responseType: 'blob' });
      saveBlob(res.data, `${nomArchive || 'documents'}.zip`);
      const nbOk = res.headers['x-documents-generes'] || ids.length;
      const nbErr = Number(res.headers['x-documents-erreurs'] || 0);
      toast.success(`${nbOk} PDF téléchargés dans l'archive${nbErr ? ` (${nbErr} en erreur, voir _erreurs.txt)` : ''}`);
    } catch (e) {
      let detail = e.response?.data?.detail;
      if (e.response?.data instanceof Blob) {
        try { detail = JSON.parse(await e.response.data.text())?.detail; } catch { /* ignore */ }
      }
      toast.error(detail || 'Erreur lors de la génération de l\'archive');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button variant="outline" onClick={telecharger} disabled={loading || !ids.length} className="border-indigo-300 text-indigo-700 hover:bg-indigo-50" data-testid="factu-telecharger-zip-btn">
      {loading ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <FolderDown className="w-4 h-4 mr-2" />}
      Télécharger les PDF ({ids.length})
    </Button>
  );
};
